if (!customElements.get('cinoton-scene-carousel')) {
  customElements.define('cinoton-scene-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.tabs = Array.from(this.querySelectorAll('[data-cinoton-scene-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-cinoton-scene-panel]'));
      this.viewport = this.querySelector('[data-cinoton-scene-viewport]');
      this.tablist = this.querySelector('.cinoton-scene-carousel__tabs');
      this.index = Math.max(0, this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true'));
      this.touchStartX = null;

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(index));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event, index));
      });
      this.querySelector('[data-cinoton-scene-previous]')?.addEventListener('click', () => this.activate(this.index - 1));
      this.querySelector('[data-cinoton-scene-next]')?.addEventListener('click', () => this.activate(this.index + 1));

      this.viewport?.addEventListener('touchstart', (event) => {
        this.touchStartX = event.changedTouches[0]?.clientX ?? null;
      }, { passive: true });
      this.viewport?.addEventListener('touchend', (event) => {
        if (this.touchStartX === null) return;
        const distance = (event.changedTouches[0]?.clientX ?? this.touchStartX) - this.touchStartX;
        this.touchStartX = null;
        if (Math.abs(distance) < 45) return;
        this.activate(this.index + (distance < 0 ? 1 : -1));
      }, { passive: true });

      this.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[data-cinoton-scene-panel]');
        const index = this.panels.indexOf(panel);
        if (index >= 0) this.activate(index);
      });
    }

    activate(nextIndex, focus = false) {
      if (!this.tabs.length) return;
      this.index = (nextIndex + this.tabs.length) % this.tabs.length;
      const activeId = this.tabs[this.index].dataset.cinotonSceneTab;

      this.tabs.forEach((tab, index) => {
        const selected = index === this.index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.cinotonScenePanel !== activeId;
      });

      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      if (this.tablist) {
        const activeTab = this.tabs[this.index];
        const left = activeTab.offsetLeft - (this.tablist.clientWidth - activeTab.offsetWidth) / 2;
        this.tablist.scrollTo({ left, behavior });
      }
      if (focus) this.tabs[this.index].focus();
    }

    handleKeydown(event, index) {
      const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (!keys.includes(event.key)) return;
      event.preventDefault();
      let nextIndex = index;
      if (event.key === 'ArrowLeft') nextIndex -= 1;
      if (event.key === 'ArrowRight') nextIndex += 1;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      this.activate(nextIndex, true);
    }
  });
}
